module.exports = __webpack_public_path__ + "img/img13.2efbb015.png";